import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { Outlet } from 'react-router-dom';

import useEventTracking from '@hooks/useEventTracking';
import { Page } from '@tracking';

import SideNav from './SideNav';

const queryClient = new QueryClient();

interface LayoutProps {
  firstName: string;
}

const Layout = ({ firstName }: LayoutProps) => {
  const { Track } = useEventTracking({
    page: Page.OrganizationAccount,
  });

  return (
    <QueryClientProvider client={queryClient}>
      <Track>
        <div className="px-16 sm:px-28">
          <div className="mx-auto md:w-[1040px]">
            <h1 className="m-0 font-suisse-screen text-headline-md text-black">
              Hello, {firstName}
            </h1>
            <p className="m-0 font-suisse-intl text-body-lg font-light text-black">
              Effortlessly handle your group subscription.
            </p>
            <div className="mt-64 flex flex-col gap-112 md:flex-row">
              <div className="relative hidden w-full md:block md:w-[188px]">
                <SideNav />
              </div>
              <div className="w-full md:w-[626px]">
                <Outlet />
              </div>
            </div>
          </div>
        </div>
      </Track>
    </QueryClientProvider>
  );
};

export default Layout;
